import {VGFormSender} from "vgformsender";
import {findAll, listener} from "../../../../../modules/vegas/js/util";
import {Modal} from "../../esm";

function onReady() {
	const forms = findAll('[data-vgformsender]');
	if (forms.length) {
		[...forms].map((form) => {
			new VGFormSender(form, {
				modal: Modal
			}).submit();
		})
	}

	const formCode = [...findAll('.form-code')];
	if (formCode.length) {
		formCode.forEach(function (el) {
			let numbers = [...findAll('.number', el)];

			if (numbers.length) {
				numbers.forEach(function (number, index) {
					number.onclick = function (el) {
						if (!numbers[0].value) {
							numbers[0].focus();
							numbers[0].removeAttribute('readonly')
						}
					};

					number.onkeyup = function (event) {
						if (event.code === 'KeyE') this.value = '';

						let input = this,
							nextInput = input.nextSibling,
							value = input.value;

						if (value.length > 1) {
							input.value = value.slice(-1)
						}

						while(nextInput && nextInput.nodeType !== 1) {
							nextInput = nextInput.nextSibling
						}

						if (input.value) {
							if (nextInput) {
								nextInput.focus();
								nextInput.removeAttribute('readonly')
							}
							input.setAttribute('readonly', 'readonly');
						}

						if (event.code === 'Backspace' || event.keyCode === 8 || event.keyCode === 46 || event.key === 'Backspace') {
							let prevInput = input.previousSibling;

							while(prevInput && prevInput.nodeType !== 1) {
								prevInput = prevInput.previousSibling;
							}

							if (prevInput) {
								prevInput.removeAttribute('readonly');
								prevInput.focus();
								prevInput.value = '';
								input.setAttribute('readonly', 'readonly');
							}
						}
					};
				});
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', onReady);
onTurboRender(onReady);

listener('submit', 'form', function (form) {
	let btn = form.querySelector('button[type="submit"]'),
		text = btn?.dataset.loadingText || '';

	if (text) {
		btn.innerText = text;
		btn.setAttribute('disabled', 'disabled')
	}
});
